<template>
    <div ref="trigger" class="scroll-trigger">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'vx-scroll-trigger',
    props: {
        parent: {
            type: null,
            required: true
        }
    },
    computed: {
        options() {
            return {
                root: this.parent,
                threshold: '0'
            }
        }
    },
    data() {
        return {
            observer: null
        }
    },
    methods: {
        handleVisibile(entry) {
            if (entry.isIntersecting) {
                this.$emit('visible')
                this.observer.disconnect()
            }
        }
    },
    mounted() {
        this.observer = new IntersectionObserver((entries) => {
            this.handleVisibile(entries[0])
        }, this.options)

        this.observer.observe(this.$refs.trigger)
    },
    beforeDestroy() {
        this.observer.disconnect()
    }
}
</script>

<style scoped>
.vx-scroll-trigger {
    background-color: inherit;
}
</style>
